export const GAME_WIDTH = 720;
export const GAME_HEIGHT = 1280;
export const GAME_DURATION = 120;

// Single source of truth for the build version. The visible stamp shown on the
// stopped screens (start / pause / game-over / victory) is built from this.
export const GAME_VERSION = "0.9.0";
export const VERSION_LABEL = `BETA · v${GAME_VERSION}`;
export const PLAYER_TARGET_Y = GAME_HEIGHT * 0.68;
export const GHOST_FRONT_LINE = GAME_HEIGHT * 0.92;

export const MUSIC_LINKS = {
  spotify: "https://open.spotify.com/intl-es/artist/02toLWG8cb48qiapCVRK6s",
  appleMusic: "https://music.apple.com/hn/artist/aim-wind-x/1800589518",
  youtubeMusic: "https://music.youtube.com/@AIMWINDX"
};

export const TERRAIN = {
  dirt: { speed: 1, tint: 0x2a241a },
  stone: { speed: 1.1, tint: 0x6f7770 },
  grass: { speed: 0.9, tint: 0x2f4b2c },
  mud: { speed: 0.8, tint: 0x23170f },
  swamp: { speed: 0.65, tint: 0x173323 },
  water: { speed: 0.72, tint: 0x123640 },
  roots: { speed: 0.85, tint: 0x2c1a12 },
  fog: { speed: 1, tint: 0xaac7b7 }
} as const;

export type TerrainType = keyof typeof TERRAIN;
